const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/notifications/api-factory');
const serviceFactory = require('../resources/notifications/service-factory');

function addRoutes({ requestHandler } = {}) {
  const notificationApi = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/alertsandnotifications/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ notificationApi });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}notifications.getUserNotifications[{keys:roleId}][{keys:lastLoginValue}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getUserNotifications(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}notifications.getUserPrefNotifications`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getUserPrefNotifications(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}notifications.getUserPrefNotifications[{keys:guidStr}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getUserPrefNotifications(req.params)
            .then(response => res.value(response))
            .catch(res.error)
      )))
    .match(`${p}notifications.saveUserPrefNotifications[{keys:alertTypes}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.saveUserPrefNotifications(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}notifications.saveUserPrefNotifications[{keys:alertTypes}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.saveUserPrefNotifications(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}notifications.markedAsRead`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.setAsReadUserNotifications(req.params)
            .then(response => res.value(response))
            .catch(res.error)
      )))
  }

module.exports = addRoutes;
